<mat-toolbar class="subtitulo">Matricula de Beneficiário na turma</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">

        <div *ngIf="matricula.aluno && matricula.aluno.id" style="padding-top: 20px;">
            <dados-aluno [aluno]="matricula.aluno"></dados-aluno>
        </div>        

        <div fxLayout="row" fxLayoutGap="50px" fxFlexFill *ngIf="!isAtualizar">

            <!-- ALUNO-->
            <div fxLayout="column" fxFlex="45%">
                <mat-toolbar class="titulopartes">Beneficiário</mat-toolbar>
                <div ngModelGroup="comboBeneficiario" fxFlex="100" fxLayoutGap="20px" style="padding-top: 15px;">
                    <combo-beneficiario [showDisplayId]="false" 
                                        [obrigatorio]="true" 
                                        [selecionado]="filtro.aluno"
                                        (valorChange)="onValorChange($event)">
                    </combo-beneficiario>
                </div>
            </div>
            <div fxLayout="column" fxFlex="45%">
                <mat-toolbar class="titulopartes">Turma</mat-toolbar>
                <div fxFlex="100" fxLayoutGap="20px" style="padding-top: 15px;">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Turma</mat-label>
                        <mat-select [(ngModel)]="matricula.turma.id" name="turma" 
                                    (selectionChange)="carregarDadosTurma()"
                                    required>
                            <mat-option></mat-option>                                
                            <mat-option *ngFor="let i of turmas" [value]="i.id">
                                {{getDadosTurma(i)}}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="turmas?.length === 0" align="start">Nenhuma turma cadastrada</mat-hint>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayoutGap="50px" fxFlexFill *ngIf="isAtualizar">
            <div fxLayout="column" fxFlex="45%">
                <mat-toolbar class="titulopartes">Turma</mat-toolbar>
                <mat-form-field style="margin: 0 20px 20px 20px">
                    <mat-select [(ngModel)]="matricula.turma.id" name="turma" 
                                disabled="">
                        <mat-option></mat-option>                                
                        <mat-option *ngFor="let i of turmas" [value]="i.id">
                            {{getDadosTurma(i)}}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="turmas?.length === 0" align="start">Nenhuma turma cadastrada</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div fxLayout="row">
            <mat-form-field style="margin: 0 0 0 20px" fxFlex="15%">
                <input matInput 
                       name="dataInicio" 
                       [matDatepicker]="dataInicio"
                       (input)="onMascaraDataInput($event)"
                       (change)="carregarDataInicioOficinas()"
                       placeholder="Data início matricula"
                       [(ngModel)]="matricula.dataInicio" required>
                <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                <mat-datepicker #dataInicio></mat-datepicker>
            </mat-form-field>

            <mat-form-field style="margin: 0 0 0 20px" fxFlex="15%">
                <input matInput 
                       name="dataDesvinculacao" 
                       [min]="matricula.dataInicio"
                       (input)="onMascaraDataInput($event)"
                       [matDatepicker]="dataDesvinculacao"
                       (change)="carregarDataInicioOficinas()"
                       placeholder="Data de desvinculação" [(ngModel)]="matricula.dataDesvinculacao">
                <mat-datepicker-toggle matSuffix [for]="dataDesvinculacao"></mat-datepicker-toggle>
                <mat-datepicker #dataDesvinculacao></mat-datepicker>
            </mat-form-field>

            <mat-form-field style="margin: 0 0 0 20px" fxFlex="70%">
                <mat-label>Descrição desligamento:</mat-label>
                <input #descricaoDesligamento matInput name="descricaoDesligamento"
                    [(ngModel)]="matricula.descricaoDesligamento" maxlength="200" (blur)="carregaDescricaoDesligamento()">
                <mat-hint align="start">{{descricaoDesligamento.value.length}} / 200</mat-hint>
            </mat-form-field>

        </div>

        <div >
            <mat-toolbar class="titulopartes">Atividades matriculadas</mat-toolbar>
            <div *ngIf="matricula.turma.oficinas?.length; else msgSemOficina">
                <div fxLayout="row">
                    <div fxLayout="column" fxFlex="100%">
                        <div fxLayout="column" fxFlex="100%" *ngFor="let o of matricula.oficinas">
                            <dados-oficina [oficina]="o" 
                                           [oficinas]="matricula.turma.oficinas"
                                           [perfilAcesso]="perfilAcesso"
                                           (onDeletar)="deletarOficina($event)"></dados-oficina>
                        </div>
                    </div>
                </div>
                <div fxLayout="row" 
                     *ngIf="perfilAcesso.insere" 
                     fxLayoutAlign="end center" 
                     fxLayoutGap="16px"
                     style="padding-top: 10px">
                    <div>
                        <button matTooltip="Adicionar nova matricula" 
                                mat-fab color="primary"
                                (click)="novaMatricula()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <ng-template #msgSemOficina>
                <div fxLayout="row" 
                     *ngIf="matricula.turma.id"
                     fxLayoutAlign="center center" >
                     <div style="text-align: center; border-style: solid; border-color: coral; width: 30%;">
                         <span style="color: blue">
                             Esta turma não possui Atividade.
                         </span>
                     </div>            
                </div>
            </ng-template>
        </div>
        
        <div *ngIf="conflitos && conflitos.length > 0" style="padding-top: 25px;">
            <mat-toolbar class="titulopartes" style="background-color: #fbad76;color: black;">
                Conflitos de matrículas
            </mat-toolbar>

            <mat-list *ngFor="let reg of conflitos">
                <div mat-subheader style="font-size: 16px;font-weight: 300;color: red;" fxLayout="row" >
                    {{reg.oficina.atividade.descricao}} - Período: {{getPeriodoConflito(reg.oficina)}} - Horário: {{reg.oficina.atividade.horaInicio}} às {{reg.oficina.atividade.horaFim}} - Dia(s): {{getDadosConflito(reg.oficina)}}
                </div>
                <mat-list-item style="padding-left: 30px;" *ngFor="let conf of reg.conflitos">                  
                  <div mat-line>{{conf.atividade.descricao}} - Período: {{getPeriodoConflito(conf)}} - Horário: {{conf.atividade.horaInicio}} às {{conf.atividade.horaFim}}</div>
                  <div mat-line>Dia(s): {{getDadosConflito(conf)}}</div>                  
                </mat-list-item>
                <mat-divider></mat-divider>
            </mat-list>
        </div>

        <!-- BOTOES -->
        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
            fxFlexFill>
            <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()"> Cadastrar
            </button>

            <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
                Atualizar
            </button>

            <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                Limpar
            </button>
            <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                Cancelar
            </button>

        </div>

    </form>

</div>
